import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Auction } from '../models/auction.model';
import { Category } from '../models/category.model';
import { ICoreStart } from '../models/core.model';

@Injectable({
  providedIn: 'root',
})
export class AuctionsService {
  private http: HttpClient = inject(HttpClient);

  public getAuctionsList(page: number = 1, limit: number = 20): Observable<Auction[]> {
    const params = new HttpParams()
      .set('page', page.toString())
    
    return this.http.get<Auction[]>(`${environment.apiUrl}auctions`, { params });
  }

  public getAuctionsListByCategory(categoryId: string, page: number = 1, limit: number = 20): Observable<Auction[]> {
    const params = new HttpParams()
      .set('page', page.toString())
    
    return this.http.get<Auction[]>(
      `${environment.apiUrl}category/${categoryId}/auctions`,
      { params }
    );
  }

  public getCodesListByCategory(categoryId: string): Observable<Auction[]> {
    return this.http.get<Auction[]>(
      `${environment.apiUrl}category/${categoryId}/auctions`
    );
  }

  public getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(`${environment.apiUrl}categories`);
  }

  public getCategoriesWithCount(): Observable<Category[]> {
    return this.http.get<Category[]>(`${environment.apiUrl}categories/auction`);
  }


  public getCodesWithCount(): Observable<Category[]> {
    return this.http.get<Category[]>(`${environment.apiUrl}categories/codes`);
  }

  public getCoreStart(): Observable<ICoreStart> {
    return this.http.get<ICoreStart>(`${environment.apiUrl}core/start`);
  }
}
